import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useOnboarding } from '../../../../context/OnboardingContext';
import { PrivateWizardLayout, WizardContainer, WizardCard, WizardActions } from '../../WizardLayout';
import Stepper from '../../Stepper';
import { registerIotDevice, getIotDeviceStatus } from '../../../../services/wizardApi';
import { toast } from 'react-toast';
import '../../../../styles/wizard.css';
import { useAddIOTDevice } from '../../../../hooks/API/wizard.api';


const SIGNAL_ICON = {
  Strong: '📶',
  Medium: '📶',
  Weak:   '📶',
};

const PROTOCOLS = [
  { key: 'wifi',      label: 'WiFi',      icon: '📶' },
  { key: 'bluetooth', label: 'Bluetooth', icon: '🔵' },
  { key: 'other',     label: 'Other',     icon: '⚙️' },
];

const PROTOCOL_CODE = {
  bluetooth: 1,
  wifi: 2,
};

const Step7IotDevicePairing = () => {
  const navigate = useNavigate();
  const { iot, project, setIot, nextStep, previousStep ,markStepCompleted,goToStep} = useOnboarding();
  const { mutate: addIotDevice } = useAddIOTDevice();
  
  const [deviceForm, setDeviceForm] = useState({
    serialNumber: '',
    ipAddress: '',
    connectionType: 'serial', // 'serial' or 'network'
    networkProtocol: '',
  });
  const [isRegistering, setIsRegistering] = useState(false);
  const [deviceData, setDeviceData] = useState(iot.device);
  const [isCheckingStatus, setIsCheckingStatus] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const [discoveredDevices, setDiscoveredDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    // If device already registered, check its status
    if (deviceData.deviceId && !deviceData.online) {
      checkDeviceStatus(deviceData.deviceId);
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDeviceForm(prev => ({ ...prev, [name]: value }));
  };

   const handleProtocolSelect = (protocol) => {
    setDeviceForm(prev => ({ ...prev, networkProtocol: protocol }));
    setSelectedDevice(null);
    handleScanDevices(protocol);
  };

   const handleScanDevices = (protocol) => {
    setIsScanning(true);
    setDiscoveredDevices([]);
    setSelectedDevice(null);

    window.postMessage(
    {
       source: "ROBITEST_CLOUD",
       action: "IOT_SCAN_DEVICES", 
       protocol: PROTOCOL_CODE[protocol] 

      },
    "*"
  );
  };

    useEffect(() => {
      const handleAgentMessage = (event) => {
        const { source, type } = event.data || {};
      const { success, devices, error,message, status, network_strength, health, device_id, paired,device_data} 
      = event?.data?.data || event?.data || {};

        if (source !== 'ROBITEST_AGENT') return;

        // ── Scan results ──
        if (type === 'IOT_SCAN_RESULTS') {
          if (success && devices) {
                const mapped = devices.map((d, index) => ({
          id: String(index),
          name: d.name,
          address: d.address,
          rssi: d.rssi,
          signal: d.rssi >= -70 ? 'Strong' : d.rssi >= -85 ? 'Medium' : 'Weak',
        }));
            setDiscoveredDevices(mapped);
          } else {
            toast.error(error || 'Scan failed, please try again');
            setDiscoveredDevices([]);
          }
          setIsScanning(false);
        }

    // ── Health check results ──
  // ── Health check results ──
      if (type === 'IOT_PAIR_DEVICE') {
        if (success && paired) {
          setDeviceData(prev => {
            const updatedDevice = {
              ...prev,              // ← always fresh, no stale closure
              deviceId: device_data?.model,
              online: true,
              signalStrength: device_data?.rssi,
              category: device_data?.category,
              battery: device_data?.battery,
            };
            setIot(prevIot => ({ ...prevIot, device: updatedDevice }));
            return updatedDevice;
          });
          toast.success(message || 'Device is online and ready!');
        } else {
          toast.error(error || 'Device is not reachable');
        }
        setIsCheckingStatus(false);
      }
        };

        window.addEventListener('message', handleAgentMessage);
        return () => window.removeEventListener('message', handleAgentMessage);
      }, []);

    const getDeviceSubtitle = (device) => {
      const parts = [];
      if (device.address) parts.push(device.address);
      if (device.rssi)    parts.push(`${device.rssi} dBm`);
      return parts.join('  ·  ');
    };

  const handleRegisterDevice = async () => {
    //  if (deviceForm.connectionType === 'serial' && !deviceForm.serialNumber.trim()) {
    //     toast.error('Please enter device serial number');
    //     return;
    //   }

      if (deviceForm.connectionType === 'network' && !selectedDevice) {
        toast.error('Please select a device');
        return;
      }

    // setIsRegistering(true);
    const payload = {
      project_id: project?.project_id,
      name: selectedDevice?.name || 'FT_38095_9C97',
      protocol:1,
      address: selectedDevice?.address || 'F4:B7:CB:42:9C:97'
    }

    addIotDevice(
       payload,
      {
        onSuccess: (data) => {
          setDeviceData({
            deviceId: data.device_id,
            online: false,
            category: project.iotCategory,
          });
          setIot(prev => ({ ...prev, device: {
            deviceId: data.device_id,
            online: false,
            category: project.iotCategory,
          }}));
          toast.success('Device registered! Checking connectivity...');
          checkDeviceStatus(data.device_id);
        },
        onError: () => {
          toast.error('Failed to register device');
        }
      } )
  };

const checkDeviceStatus = (deviceId) => {
  setIsCheckingStatus(true);

  // window.postMessage({
  //   source: "ROBITEST_CLOUD",
  //   action: "IOT_CHECK_HEALTH",
  //   protocol: PROTOCOL_CODE[deviceForm.networkProtocol] || 1,
  //   address: selectedDevice?.address || '',
  //   device_id: deviceId,
  // }, "*");
    window.postMessage({
    source: "ROBITEST_CLOUD",
    action: "IOT_PAIR_REQUEST",
    address: selectedDevice?.address || '',
  }, "*");
  

  // Stop waiting after 1 minute
  setTimeout(() => setIsCheckingStatus(false), 60000);
};

  const handleContinue = () => {
    if (!deviceData.online) {
      toast.error('Device must be online to continue');
      return;
    }
     markStepCompleted(7);
     goToStep(8);
    navigate('/app/onboarding?step=8');
  };

  return (
    <PrivateWizardLayout>
      <WizardContainer>
        <Stepper currentStep={7} completedSteps={[1, 2, 3, 4, 5, 6]} />
        
        <WizardCard
          title="Add your device"
          subtitle="Register and pair your IoT device for testing"
        >
          {!deviceData.deviceId ? (
            // Registration form
            <div>
              {/* Connection type selection */}
              <div style={{ marginBottom: '2rem' }}>
                <label className="wizard-form-label">Connection Method</label>
                <div style={{ display: 'flex', gap: '1rem' }}>
                  <button
                    type="button"
                    onClick={() => setDeviceForm(prev => ({ ...prev, connectionType: 'serial' }))}
                    className={`wizard-btn ${deviceForm.connectionType === 'serial' ? 'wizard-btn-primary' : 'wizard-btn-secondary'}`}
                    style={{ flex: 1 }}
                  >
                    📟 Serial/QR Code
                  </button>
                  <button
                    type="button"
                    onClick={() => setDeviceForm(prev => ({ ...prev, connectionType: 'network' }))}
                    className={`wizard-btn ${deviceForm.connectionType === 'network' ? 'wizard-btn-primary' : 'wizard-btn-secondary'}`}
                    style={{ flex: 1 }}
                  >
                    🌐 Network Discovery
                  </button>
                </div>
              </div>

              {/* Serial number input */}
              {deviceForm.connectionType === 'network' && (
                <div>
                  {/* Protocol selector */}
                  <div className="wizard-form-group">
                    <label className="wizard-form-label">Select Protocol</label>
                    <div style={{ display: 'flex', gap: '0.75rem' }}>
                      {PROTOCOLS.map(({ key, label, icon }) => (
                        <button
                          key={key}
                          type="button"
                          onClick={() => handleProtocolSelect(key)}
                          className={`wizard-btn ${deviceForm.networkProtocol === key ? 'wizard-btn-primary' : 'wizard-btn-secondary'}`}
                          style={{ flex: 1 }}
                        >
                          {icon} {label}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Scanning spinner */}
                  {isScanning && (
                    <div style={{ textAlign: 'center', padding: '2rem 1rem' }}>
                      <div style={{
                        width: '32px',
                        height: '32px',
                        border: '3px solid rgba(76,201,240,0.3)',
                        borderTopColor: 'var(--success-color)',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 0.75rem',
                      }} />
                      <p style={{ color: 'var(--text-secondary)', margin: 0, fontSize: '0.9rem' }}>
                        Scanning for devices...
                      </p>
                    </div>
                  )}

                  {/* Device list */}
                  {!isScanning && discoveredDevices.length > 0 && (
                    <div className="wizard-form-group">
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '0.75rem',
                      }}>
                        <label className="wizard-form-label" style={{ margin: 0 }}>
                          Nearby Devices ({discoveredDevices.length} found)
                        </label>
                        <button
                          type="button"
                          onClick={() => handleScanDevices(deviceForm.networkProtocol)}
                          className="wizard-btn wizard-btn-secondary"
                          style={{ padding: '0.25rem 0.75rem', fontSize: '0.8rem' }}
                        >
                          🔄 Rescan
                        </button>
                      </div>

                      <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.5rem',
                      maxHeight: '320px',
                      overflowY: 'auto',
                      paddingRight: '4px',
                    }}>
                        {discoveredDevices.map(device => (
                          <div
                            key={device.id}
                            onClick={() => setSelectedDevice(device)}
                            style={{
                              padding: '0.875rem 1rem',
                              borderRadius: '8px',
                              border: `2px solid ${selectedDevice?.id === device.id ? 'var(--primary-color, #4CC9F0)' : 'var(--border-color, #e2e8f0)'}`,
                              background: selectedDevice?.id === device.id ? 'rgba(76,201,240,0.08)' : 'white',
                              cursor: 'pointer',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              transition: 'all 0.15s ease',
                            }}
                          >
                            <div>
                              <div style={{ fontWeight: '500', fontSize: '0.9rem' }}>
                                📱 {device.name}
                              </div>
                              <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginTop: '0.2rem' }}>
                                {getDeviceSubtitle(device)}
                              </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                              <span style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                                {SIGNAL_ICON[device.signal]} {device.signal}
                              </span>
                              {selectedDevice?.id === device.id && (
                                <span style={{ color: 'var(--primary-color, #4CC9F0)', fontWeight: '600' }}>✓</span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* No devices found */}
                  {!isScanning && deviceForm.networkProtocol && discoveredDevices.length === 0 && (
                    <div style={{
                      textAlign: 'center',
                      padding: '2rem',
                      background: 'var(--bg-gray-50)',
                      borderRadius: '8px',
                      color: 'var(--text-secondary)',
                      fontSize: '0.9rem',
                    }}>
                      <p style={{ margin: '0 0 0.75rem' }}>No devices found nearby</p>
                      <button
                        type="button"
                        onClick={() => handleScanDevices(deviceForm.networkProtocol)}
                        className="wizard-btn wizard-btn-secondary"
                        style={{ fontSize: '0.85rem' }}
                      >
                        🔄 Try Again
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* ── Device info ── */}
              <div style={{
                marginTop: '2rem',
                padding: '1rem',
                background: 'var(--bg-gray-50)',
                borderRadius: '8px',
                fontSize: '0.875rem',
              }}>
                <div style={{ marginBottom: '0.5rem' }}>
                  <strong>Device Type:</strong> {project.iotCategory || 'Not specified'}
                </div>
                <div>
                  <strong>Connectivity:</strong> {project.iotConnectivity || 'Not specified'}
                </div>
              </div>

              {/* ── Register button ── */}
              <div style={{ marginTop: '2rem' }}>
                <button
                  onClick={handleRegisterDevice}
                  disabled={
                    isRegistering ||
                    (deviceForm.connectionType === 'network' && !selectedDevice) ||
                    (deviceForm.connectionType === 'serial' && !deviceForm.serialNumber.trim())
                  }
                  className="wizard-btn wizard-btn-primary"
                  style={{ width: '100%' }}
                >
                  {isRegistering ? (
                    <>
                      <span className="spinner-small" style={{ marginRight: '0.5rem' }} />
                      Registering Device...
                    </>
                  ) : (
                    '✓ Register Device'
                  )}
                </button>
              </div>
            </div>

          ) : deviceData.online ? (
            // ── Device online ──
            <div style={{ padding: '2rem', textAlign: 'center' }}>
              <div style={{
                width: '80px', height: '80px',
                margin: '0 auto 1.5rem',
                borderRadius: '50%',
                background: 'var(--success-bg)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '2.5rem',
              }}>
                ✓
              </div>
              <h3 style={{ fontSize: '1.75rem', fontWeight: '600', marginBottom: '1rem', color: 'var(--success-color)' }}>
                Device Online
              </h3>
              <p style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
                Your device is connected and ready for testing
              </p>

              <div style={{
                maxWidth: '500px', margin: '0 auto', padding: '2rem',
                background: 'var(--bg-gray-50)', borderRadius: '12px', textAlign: 'left',
              }}>
                <h4 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '1.5rem', textAlign: 'center' }}>
                  Device Status
                </h4>
                <div style={{ display: 'grid', gap: '1rem' }}>
                  {[
                    { label: 'Status',    value: <span style={{ color: 'var(--success-color)', fontWeight: '600' }}>● Online</span> },
                    { label: 'Device ID', value: <span style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>{deviceData.deviceId?.substring(0, 12)}...</span> },
                    deviceData.battery !== undefined && { label: 'Battery', value: `🔋 ${deviceData.battery}%` },
                    deviceData?.health && { label: 'Health', value: deviceData?.health },
                    deviceData.signalStrength !== undefined && { label: 'Signal Strength', value: `📶 ${deviceData.signalStrength} dBm` },
                    { label: 'Category', value: <span style={{ textTransform: 'capitalize' }}>{deviceData.category?.replace('_', ' ')}</span> },
                  ].filter(Boolean).map(({ label, value }) => (
                    <div key={label} style={{
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                      padding: '0.75rem', background: 'white', borderRadius: '6px',
                    }}>
                      <span style={{ color: 'var(--text-secondary)' }}>{label}</span>
                      <span style={{ fontWeight: '600' }}>{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          ) : (
            // ── Checking status ──
            <div style={{ padding: '2rem', textAlign: 'center' }}>
              <h3 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Device Registered</h3>
              <p style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
                Checking device connectivity...
              </p>

              {isCheckingStatus && (
                <div style={{
                  padding: '2rem',
                  background: 'rgba(76, 201, 240, 0.1)',
                  border: '1px solid rgba(76, 201, 240, 0.3)',
                  borderRadius: '12px',
                  display: 'inline-block',
                }}>
                  <div style={{
                    width: '48px', height: '48px',
                    margin: '0 auto 1rem',
                    border: '4px solid rgba(76, 201, 240, 0.3)',
                    borderTopColor: 'var(--success-color)',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                  }} />
                  <p style={{ margin: 0, fontWeight: '600' }}>Waiting for device to come online...</p>
                  <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                    Please ensure the device is powered on and connected
                  </p>
                </div>
              )}

              {!isCheckingStatus && (
                <button
                  onClick={() => checkDeviceStatus(deviceData.deviceId)}
                  className="wizard-btn wizard-btn-secondary"
                >
                  🔄 Check Status Again
                </button>
              )}
            </div>
          )}

          

          <WizardActions
            showBack={true}
            onBack={() => {
              previousStep();
              navigate('/app/onboarding?step=6');
            }}
            showNext={true}
            onNext={handleContinue}
            nextLabel="Continue"
            nextDisabled={!deviceData.online}
          />
        </WizardCard>
      </WizardContainer>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .spinner-small {
          display: inline-block;
          width: 14px;
          height: 14px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.6s linear infinite;
        }
      `}</style>
    </PrivateWizardLayout>
  );
};

export default Step7IotDevicePairing;